"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.from = void 0;
var _ApolloLink = require("apollo-stack-hubspot/@apollo/client/link/core/ApolloLink");
var from = exports.from = _ApolloLink.ApolloLink.from;